import React, { useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';

import { withRouter } from 'react-router-dom';

import classNames from 'classnames';

import asyncComponent from 'Demora/AsyncComponent';

const Tabs = asyncComponent(() => import('./Tabs'));

import alert from 'Demora/modals/alert';

const a = React;

let currentValues = {};

const elementsInTabs = {};

export default withRouter((props) => {
	const formId = 'DM_FORM3_' + new Date().getTime() + Math.random();

	const [fields, setFields] = useState([]);

	const [saving, setSaving] = useState(false);

	const [multiInstant, setMultiInstant] = useState({});

	const [numberSaves, setNumberSaves] = useState(0);

	const form = props.form;

	const {
		control,
		formState,
		formState: { errors },
		handleSubmit,
		register,
		setValue,
		watch,
	} = useForm({ defaultValues: form.defaultValues });

	const button = form.button;

	const recordElementInTabs = (tabTitle, element) => {
		elementsInTabs[element.name] = {
			element,
			tabTitle,
		};
	};

	useEffect(() => {
		const fields = [];
		const multiInstant = {};

		if (!fields.map) {
			fields = [fields];
		}

		const f = !form.fields.map ? [form.fields] : form.fields;

		f.map((field) => {
			fields.push(field);
			if (field.allowMultipleValues) {
				const n = field.name;

				if (!multiInstant[n]) {
					multiInstant[n] = 1;
				}

				for (var i = 1; i < multiInstant[n]; i++) {
					let field1 = Object.assign({}, field);

					field1.name = n + '_' + i;
					field1.value = '';

					fields.push(field1);
				}
			}
		});
		setMultiInstant(multiInstant);
		setFields(fields);
	}, []);

	useEffect(() => {
		const errorKeys = Object.keys(errors);

		const errorLength = errorKeys.length;

		const errorMessage = [];

		if (errorLength > 0) {
			let urlToPushTo;

			for (var i = 0; i < errorLength; i++) {
				const el1 = elementsInTabs[errorKeys[i]];

				const error = errors[errorKeys[i]];

				const failedValidation = el1.element.failedValidation
					? el1.element.failedValidation(error.ref.value)
					: false;

				errorMessage.push(
					<div key={i}>
						{failedValidation
							? failedValidation
							: el1.element.label + ' is required'}
					</div>
				);

				if (!urlToPushTo && el1.tabTitle) {
					urlToPushTo = el1.tabTitle.join('/');
				}
			}

			if (urlToPushTo) {
				props.history.push(urlToPushTo);
			}
		}
		if (errorMessage.length > 0) {
			alert('missing_info', 'Some information is missing', errorMessage);
		}
	}, [numberSaves]);

	const onSubmit = function (e) {
		const data = handleSubmit(onSubmit2)(e);

		setTimeout(() => setNumberSaves(numberSaves + 1), 1);

		return data;
	};

	const onSubmit2 = function (data) {
		setSaving(true);

		Object.keys(multiInstant).map((k) => {
			let v = multiInstant[k];

			let o = [];

			o.push(data[k]);

			for (var i = 0; i < v; i++) {
				let kk = k + '_' + (i + 1);
				o.push(data[kk]);
				delete data[kk];
			}

			data[k] = o;
		});

		const submit = form.submit(data);

		if (!submit) {
			return;
		}

		setSaving(true);

		submit.then((success) => {
			if (form.clearFormAfterSubmit && success) {
				const values = {};
			}

			setSaving(false);
		});
	};

	const checkValues = function (element, e) {
		let v;

		if (element.inputType === 'checkbox') {
			v = e.currentTarget.checked;
		} else {
			v = e.currentTarget.value;
		}

		if (element.inputType === 'textarea') {
			const h = e.target.scrollHeight;

			if (!element.maxHeight || h < element.maxHeight) {
				e.target.style.height = 'inherit';
				e.target.style.height = `${e.target.scrollHeight}px`;
			}
		}

		if (element.onChange) {
			element.onChange(v);
		} else {
			form.onChange && form.onChange(e.currentTarget.name, v);
		}
	};

	const watches = {};

	const showIf = function (element) {
		const watches1 = element.watches;

		watches1 &&
			watches1.map((w) => {
				addToWatches(w);
			});

		if (!element.showIf) {
			return true;
		}

		return element.showIf(element, watches);
	};

	const addToWatches = function (name) {
		if (!watches[name]) {
			watches[name] = watch(name);
		}
	};

	const formGroupElement = function (key, element, tabTitle) {
		if (element.inputType === 'hidden') {
			return null;
		}

		const si = showIf(element);

		switch (element.inputType) {
			case 'multiple':
				const defaultValues = element.fields;

				const { append, fields, insert, move, prepend, remove, swap } =
					useFieldArray({
						control,
						name: element.name,
					});

				return (
					<div key={key} className={classNames('col', !si && 'd-none')}>
						{fields.map((field, index) => {
							return (
								<div key={field.id} className='border row my-2 form-group'>
									<div className='col flex-grow-1'>
										<div className='row'>
											{element.fields.map((field1) => {
												field1 = Object.assign({}, field1);

												const name = `${field.name}.${index}.${field1.name}`;

												field1.watches &&
													field1.watches.map((f) => {
														addToWatches(`${field.name}.${index}.${f}`);
													});

												field1.name = name;

												return renderLabelAndInput({
													deleteMultiField:
														element.minNumber &&
														element.minNumber({
															element,
															watches,
														}) < fields.length
															? () => remove(index)
															: null,
													element: field1,
													key: field1.name,
													tabTitle,
												});
											})}
										</div>
									</div>
									{element.showDeleteButton !== false &&
										element.minNumber &&
										element.minNumber({
											element,
											watches,
										}) < fields.length && (
											<div className='col flex-grow-0'>
												<button
													className='btn btn-danger'
													onClick={() => remove(index)}
												>
													Delete
												</button>
											</div>
										)}
								</div>
							);
						})}
						<div className='text-right mt-3 form-group'>
							{element.maxNumber({ element, watches }) > fields.length && (
								<span
									className='btn btn-primary'
									onClick={() =>
										append({
											name: element.name,
										})
									}
								>
									Add {element.multiName}
								</span>
							)}
						</div>
					</div>
				);
		}

		return (
			<div
				key={key}
				className={classNames(
					'bg-light border form-group pl-2 pr-1 pt-1 pb-2 pb-md-1',
					!si && 'd-none'
				)}
			>
				<div className='row'>
					{renderLabelAndInput({ key, element, tabTitle })}
				</div>
			</div>
		);
	};

	const multiAdd = (e, field) => {
		e.stopPropagation();

		const f = field.name.replace(/_[0-9]*$/, '');

		let m = multiInstant[f];

		setMultiInstant((multiInstant) => {
			multiInstant[f]++;
			return multiInstant;
		});

		setFields((fields) => {
			const field1 = Object.assign({}, field);
			field1.name = f + '_' + m;

			let ii = 0;

			fields.map((ff, iii) => {
				if (ff.name === f) {
					ii = iii;
				}
			});

			ii += m;

			fields.splice(ii, 0, field1);

			return [...fields];
		});
	};

	const renderLabelAndInput = function (d) {
		const { deleteMultiField, element, key, tabTitle } = d;
		const form = props.form;

		const si = showIf(element);

		recordElementInTabs(tabTitle, element);

		if (element.setValue) {
			element.setValue((value) => {
				setValue(element.name, value);

				checkValues(element, {
					currentTarget: document.querySelector(
						'#' + formId + ' *[name="' + element.name + '"]'
					),
					target: document.querySelector(
						'#' + formId + ' *[name="' + element.name + '"]'
					),
				});
			});
		}

		switch (element.inputType) {
			case 'custom':
				return element.render({
					addToWatches,
					checkValues,
					control,
					deleteMultiField,
					element,
					key,
					onSubmit,
					register,
					saving,
					setValue,
					watches,
				});

			default:
				return [
					element.label && (
						<label
							key={key + 0}
							className={classNames(
								!si && 'd-none',
								'col-form-label',
								element.labelClassName
									? element.labelClassName
									: (form.labelsAboveFields || element.inputType == 'subtitle'
											? 'col-md-12'
											: 'col-md-4') +
											(element.inputType == ' checkbox' ? ' col-6' : '')
							)}
						>
							{element.inputType == 'subtitle' ||
							element.inputType == 'plainText' ? (
								element.inputType == 'subtitle' ? (
									<h3>{element.label}</h3>
								) : (
									<span>{element.label}</span>
								)
							) : (
								<span>
									{element.label}{' '}
									{element.required && (
										<strong
											className=' d-inline align-text-top'
											style={{
												fontSize: '90%',
												lineHeight: '100%',
											}}
										>
											*
										</strong>
									)}
								</span>
							)}
						</label>
					),

					<div
						key={key + 1}
						className={classNames(
							!si && 'd-none',
							element.inputClassContainerName
								? element.inputClassContainerName
								: (form.labelsAboveFields || !element.label
										? 'col-md-12'
										: element.allowMultipleValues
											? 'col'
											: 'col-md-8') +
										(element.inputType == ' checkbox'
											? ' col-6 d-flex align-items-center'
											: '')
						)}
					>
						{element.inputType === 'plainText' && element.value}

						{element.inputType !== 'textarea' &&
							element.inputType !== 'select' &&
							element.inputType !== 'plainText' && (
								<input
									type={element.inputType}
									className={classNames(
										element.inputClassName ?? 'form-control',
										!!errors[element.name] && 'border border-danger'
									)}
									style={
										element.inputType === 'checkbox' ? { width: '18px' } : {}
									}
									disabled={saving || element.disabled}
									maxLength={element.maxLength}
									placeholder={element.placeHolder}
									{...register(element.name, {
										maxLength: element.maxLength,
										required: element.required,
										onChange: (e) => {
											checkValues(element, e);
										},
										value: element.value,
									})}
									{...element.additional_params}
								/>
							)}

						{element.inputType === 'select' && (
							<select
								className='form-control'
								name={element.name}
								{...register(element.name, {})}
							>
								{element.options.map((option, i) => {
									return (
										<option key={i} value={option.value}>
											{option.name}
										</option>
									);
								})}
							</select>
						)}

						{element.inputType === 'textarea' && (
							<textarea
								className={classNames(
									element.inputClassName ?? 'form-control',
									!!errors[element.name] && 'border border-danger'
								)}
								disabled={saving || element.disabled}
								placeholder={element.placeHolder}
								maxLength={element.maxLength}
								{...register(element.name, {
									maxLength: element.maxLength,
									required: element.required,
									onChange: (e) => {
										checkValues(element, e);
									},
									value: element.value,
								})}
							/>
						)}

						{errors[element.name] && (
							<p className='text-danger'>
								{element.errorMessage
									? element.errorMessage
									: 'This is required'}
							</p>
						)}

						{!!element.helpMessage && (
							<small className='form-text text-muted px-1 pb-2'>
								{element.helpMessage}
							</small>
						)}
					</div>,
					element.allowMultipleValues ? (
						<div className='flex-grow-0' key={key + 2}>
							<i
								className='fas fa-plus mr-2'
								style={{ marginTop: '11px' }}
								onClick={(e) => multiAdd(e, element)}
							/>
						</div>
					) : null,
				];
		}
	};

	const drawRows = function (row, tabTitle) {
		const si = showIf(row);

		return row.rows.map((row, key) => {
			return (
				<div
					className={classNames('row', row.className, !si && 'd-none')}
					key={key}
				>
					{drawElement(row, key, tabTitle)}
				</div>
			);
		});
	};

	const drawTabs = function (tabs, key, tabTitle = []) {
		tabs = tabs.tabs;

		const si = showIf(tabs);

		if (tabTitle.length === 0) {
			tabTitle.push(tabs.uri);
		}

		const tabContent = tabs.tabs.map((tab, key) => {
			const newTabTitle = [...tabTitle];

			newTabTitle.push(tab.title.toLowerCase());

			return {
				title: tab.title,
				pane: drawElement(tab, key, newTabTitle),
			};
		});

		return (
			<Tabs
				key={key}
				hideTabLinks={tabs.hideTabLinks}
				includeQueryString={!!tabs.includeQueryString}
				param={tabs.param}
				tabs={tabContent}
				uri={tabs.uri}
			/>
		);
	};

	const drawCols = function (col, tabTitle) {
		const si = showIf(col);

		return col.cols.map((col, key) => {
			return (
				<div
					className={classNames(
						col.className ? col.className : 'col',
						!si && 'd-none'
					)}
					key={key}
				>
					{drawElement(col, key, tabTitle)}
				</div>
			);
		});
	};

	const drawElement = function (element, key, tabTitle) {
		const si = showIf(element);

		if (element.tabs) {
			return drawTabs(element, key, tabTitle);
		}

		if (element.rows && element.rows.map) {
			return drawRows(element, tabTitle);
		}

		if (element.cols) {
			return drawCols(element, tabTitle);
		}

		if (element.elements) {
			return element.elements.map((element, key) => {
				return formGroupElement(key, element, tabTitle);
			});
		}

		return formGroupElement(key, element, tabTitle);
	};

	if (fields.length === 0) {
		return null;
	}

	return (
		<form onSubmit={onSubmit} id={formId}>
			{fields.map((element, key) => {
				return drawElement(element, key);
			})}
			<div
				className={classNames(
					'col-md-12',
					button.position ? 'text-' + button.position : 'center'
				)}
			>
				<input
					className={classNames('btn', button.class)}
					disabled={saving || button.disabled}
					type='submit'
					value={button.text}
				/>
			</div>
		</form>
	);
});
